import { styled } from '@styledComponents';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { TextPairing } from '@components/TextPairing';
import { Columns } from '@components/Columns';
import { Flex } from '@components/Flex';
import { Box } from '@components/Box';

export const StyledSection = styled(Box)<{ height: number }>`
  position: relative;
  z-index: 1;
  contain: strict;
  width: 100%;
  height: 690px;
  ${themeMediaQuery('tablet')} {
    height: 900px;
  }
  ${themeMediaQuery('sm')} {
    height: ${({ height }) => height}px;
  }
`;

export const MainBackgroundImage = styled(Flex)<{
  height: number;
  backgroundImage: string;
  backgroundImageMobile: string;
}>`
  background-color: #ffffff;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  position: relative;
  background-repeat: no-repeat;
  justify-content: center;
  height: 579px;
  background-position: -300px top;
  background-size: cover !important;
  background: url(${(props) => cloudAssetUrl(props.backgroundImageMobile, { optimization: 'mild' })});
  ${themeMediaQuery('tablet')} {
    height: 800px;
  }
  ${themeMediaQuery('sm')} {
    height: ${({ height }) => height}px;
    background-position: initial;
    background-size: contain;
    background: url(${(props) => cloudAssetUrl(props.backgroundImage, { optimization: 'mild' })});
  }
`;

export const GradientWrap = styled.div`
  width: 100%;
  position: absolute;
  top: 232px;
  left: 0;
  background: linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
  display: block;
  height: 100%;
  ${themeMediaQuery('sm')} {
    display: none;
    height: 250px;
  }
`;

export const HeroVideoContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 50%;
  top: 46%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
`;

export const HeroBodymovinWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const HeroVideoWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  transform-origin: center center;
  overflow: hidden;
  > video {
    width: 100vw;
    height: 100%;
    object-fit: cover;
    position: absolute;
    left: 0;
  }
  #registry-hero-video-overlay {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    background-color: #000;
    z-index: 3;
    opacity: 0.25;
  }
`;

export const HeroTextPairing = styled(TextPairing)`
  .text-pairing-title,
  .text-pairing-body {
    width: 285px;
  }
  ${themeMediaQuery('below_sm')} {
    justify-content: center;
    .text-pairing-title {
      max-width: 100%;
      font-size: 38px;
      margin-top: 128px;
    }
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title,
    .text-pairing-body {
      width: 372px;
    }
  }
`;

export const RegistryHeroTextColumn = styled(Columns)`
  position: relative;
  height: 100%;
  z-index: 1;
  padding-left: ${themeSpace(5)};
  padding-right: ${themeSpace(5)};
  ${themeMediaQuery('tablet')} {
    display: flex;
    align-items: flex-end;
    margin-bottom: ${themeSpace(7)};
  }
  ${themeMediaQuery('sm')} {
    display: flex;
    align-items: flex-end;
    margin-bottom: ${themeSpace(5)};
  }
  ${themeMediaQuery('md')} {
    align-items: center;
    padding-left: 5%;
  }
  ${themeMediaQuery('xl')} {
    padding-left: ${themeSpace(5)};
  }
`;
